export default __webpack_public_path__ + "static/media/kb-article.081ee2c3.jpg";